/**
 * Catálogos de valores válidos para los campos enum del padrón. Se mantienen
 * sincronizados con `server/src/domain/catalogs/*` y con la whitelist de
 * `server/src/domain/validators/row.validator.ts`.
 *
 * Si el backend agrega un valor nuevo (ej. otro parentesco), hay que actualizar
 * acá también — el backend SIEMPRE valida con su propia whitelist, así que un
 * desync no es un agujero de seguridad, pero el usuario vería el `<option>` y
 * después el server le devolvería 400. Mantenerlo igual evita confusión.
 */

export interface OpcionCatalogo {
  value: string;
  label: string;
}

/** Sexo según RENAPER y archivo de Binary. */
export const SEXO_OPCIONES: OpcionCatalogo[] = [
  { value: 'M', label: 'Masculino' },
  { value: 'F', label: 'Femenino' },
];

/** Nacionalidad según el catálogo abreviado de Binary. */
export const NACIONALIDAD_OPCIONES: OpcionCatalogo[] = [
  { value: 'AR', label: 'Argentina' },
  { value: 'EX', label: 'Extranjera' },
];

/** Tipo de documento; AR usa DNI, EX usa PA (pasaporte). */
export const TIPO_DOC_OPCIONES: OpcionCatalogo[] = [
  { value: 'DNI', label: 'DNI' },
  { value: 'PA', label: 'Pasaporte (PA)' },
];

/**
 * Parentesco (Anexo I). Catálogo reducido por requerimiento del producto:
 * el plan corporativo cubre titular + cónyuge + hijo + adherente (cualquier
 * otro adulto que el titular decida sumar al plan, ej. padre, suegro).
 */
export const PARENTESCO_OPCIONES: OpcionCatalogo[] = [
  { value: '0', label: 'Titular' },
  { value: '5', label: 'Cónyuge' },
  { value: '7', label: 'Hijo' },
  { value: '13', label: 'Adherente' },
];

/**
 * Estado civil (Anexo II). Reducido a 3 opciones por requerimiento de Binary:
 * Soltero, Casado (cubre unión convivencial) y Separado/Divorciado.
 */
export const ESTADO_CIVIL_OPCIONES: OpcionCatalogo[] = [
  { value: 'S', label: 'Soltero/a' },
  { value: 'C', label: 'Casado/a' },
  { value: 'P', label: 'Separado/a — Divorciado/a' },
];

/**
 * Map de campo del asociado → opciones de su select. Usado por modales y
 * formularios para construir dinámicamente el control adecuado.
 */
export const CAMPO_OPCIONES: Record<string, OpcionCatalogo[]> = {
  sexo: SEXO_OPCIONES,
  nacionalidad: NACIONALIDAD_OPCIONES,
  tipoDoc: TIPO_DOC_OPCIONES,
  parentesco: PARENTESCO_OPCIONES,
  estadoCivil: ESTADO_CIVIL_OPCIONES,
};
